'use client';

import { useSession } from 'next-auth/react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

interface AuthRedirectProps {
  isLandingPage?: boolean;
}

export function AuthRedirect({ isLandingPage }: AuthRedirectProps) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useSession({
    required: true,
    onUnauthenticated() {
      if (!isLandingPage || pathname === '/papers') {
        const params = searchParams?.toString();
        const callbackUrl = `${pathname}${params ? `?${params}` : ''}`;
        router.push(`/login?callbackUrl=${encodeURIComponent(callbackUrl)}`);
      }
    },
  });

  return null;
}
